import {
  DagsterApplicationRunsPage,
  DagsterApplicationRunsPageLoading,
} from '../Platform/PlatformDagsterPage/DagsterApplicationRunsPage'
import { Suspense } from 'react'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { WorkspacesBreadcrumbs } from './WorspacesBreadcrumbs'
import { useCurrentWorkspace } from './useCurrentWorkspace'

export function WorkspaceDagsterPageV2() {
  const { app_id: applicationId, project_id: projectId } = useCurrentWorkspace()
  return (
    <>
      <WorkspacesBreadcrumbs title="Dagster" />
      <QueryErrorBoundary errorMessage="Failed to fetch dagster runs">
        <Suspense fallback={<DagsterApplicationRunsPageLoading />}>
          <DagsterApplicationRunsPage appId={applicationId} projectId={projectId} />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}
